import { createFileRoute, redirect } from '@tanstack/react-router';
import { ssrForPublicOnly } from '@/lib/ssr-utils';
import { urlSanitize } from '@/lib/utils';
import { buildItemPageHead, ItemPageView, loadItemPage } from './-item-page';
import ItemNotFound from './$name/-components/item-not-found';
import ItemSkeleton from './$name/-components/item-skeleton';

export const Route = createFileRoute('/item/$uin/$name')({
  ssr: ssrForPublicOnly,
  loader: async ({ params }) => {
    const data = await loadItemPage(params.uin);

    if ('item' in data) {
      if (!data.item.name) {
        throw redirect({
          to: '/item/$uin',
          params: { uin: params.uin },
          throw: true,
        });
      }

      const sanitizedName = urlSanitize(data.item.name);
      if (params.name !== sanitizedName) {
        throw redirect({
          to: '/item/$uin/$name',
          params: { uin: params.uin, name: sanitizedName },
          throw: true,
        });
      }
    }

    return data;
  },
  head: ({ loaderData }) => buildItemPageHead(loaderData),
  pendingComponent: ItemSkeleton,
  notFoundComponent: ItemNotFound,
  component: ItemNamePage,
});

function ItemNamePage() {
  const data = Route.useLoaderData();
  return <ItemPageView data={data} />;
}
